import CoursesPage from './CoursesPage';
import { CoursesPageProps, CoursesPageValueProps } from './types';

export type { CoursesPageProps, CoursesPageValueProps };
export default CoursesPage;
